import { render, staticRenderFns } from "./MallaAddNew.vue?vue&type=template&id=3db8bd3c&"
import script from "./MallaAddNew.vue?vue&type=script&lang=js&"
export * from "./MallaAddNew.vue?vue&type=script&lang=js&"
import style0 from "./MallaAddNew.vue?vue&type=style&index=0&id=3db8bd3c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports